import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "titleDashboard" }

import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
import type { Ref } from 'vue';

// Store, I18n y Servicios...
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { 
    getAllStatusData, 
    getAlarmDashboard, 
    getAllOperability, 
    getAlarmRecurrent 
} from '@/services/Smartlink/Principal';
import { 
    getLastRXLVLandSNR, 
    getAllLatencyLast, 
    getAllHexagon 
} from '@/services/Smartlink/Map';

import NetworkChart from '@/components/SmartLink/maps/NetworkChart.vue';
import KPICOMPONENT from '@/components/SmartLink/dashboard/KPI-Component.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

import { OBJ_ALARM_TYPE } from '@/interfaces/SmartLink/Equipos';
import { LABELS, STRING_GENERAL } from '@/constants/labels';
import axios from 'axios';
import CONSTAPIS, { TIMEOUTTIME } from '@/constants/apis';
import { TOKEN } from '@/constants/labels';


export default /*@__PURE__*/_defineComponent({
  __name: 'DashBoardView',
  setup(__props) {

const store = useStore();
const { t } = useI18n();

const projectName = computed(() => store.state.projectName);
const INTERVALRECARGE = projectName.value === 'SmartLinkDEMO' ? (1/3) : (10/6);

// Contenedores de datos desacoplados
const normalAlarmsData = ref<OBJ_ALARM_TYPE>({ distri: [], acceso: [], client: [] });
const recurrentAlarmsData = ref([]);
const operabilityData = ref({
    distribución: { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 },
    acceso: { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 },
    cliente: { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 }
});
const countEquipStatus = ref({
    distri: { ok: 0, alarm: 0, alert: 0, down: 0 },
    acceso: { ok: 0, alarm: 0, alert: 0, down: 0 },
    client: { ok: 0, alarm: 0, alert: 0, down: 0 },
});

const statusEquips = ref([]);
const mapData = ref({
    pmpsm: [], rajant: [], pmpap: [], polylines: [], rxlvlSnr: [], latency: [], hexagon: undefined
});

const showNetWork = ref(true);
const showKPI = ref(false);
const valorCount = ref(0);
const interval = ref();

async function fetchAllDashboardData() {
    try {
        const [
            statusRes, 
            alarmsNormalRes,     // API Normal para KPIs
            recurrentRes,        // API Recurrente para Network
            operabilityRes, 
            rxlvlSnrRes,
            latencyRes,
            hexagonRes,
            pmpsmRes,
            rajantRes,
            pmpapRes,
            polylinesRes
        ] = await Promise.all([
            getAllStatusData(),
            getAlarmDashboard(),   // Normal
            getAlarmRecurrent(),   // Recurrente
            getAllOperability(),
            getLastRXLVLandSNR(),
            getAllLatencyLast(),
            getAllHexagon(),
            axios.get(CONSTAPIS.APIS.value.maps.getAllLatLngSM, { timeout: TIMEOUTTIME, headers: { Authorization: `Bearer ${TOKEN}` } }),
            axios.get(CONSTAPIS.APIS.value.maps.getAllLatLngRAJ, { timeout: TIMEOUTTIME, headers: { Authorization: `Bearer ${TOKEN}` } }),
            axios.get(CONSTAPIS.APIS.value.maps.getAllLatLngAP, { timeout: TIMEOUTTIME, headers: { Authorization: `Bearer ${TOKEN}` } }),
            axios.get(CONSTAPIS.APIS.value.maps.getAllPolylines, { timeout: TIMEOUTTIME, headers: { Authorization: `Bearer ${TOKEN}` } })
        ]);

        // 1. Estados
        if (statusRes.status === 200) {
            countEquipStatus.value = statusRes.data.countEquipData;
            statusEquips.value = statusRes.data.statusEquipData;
            showKPI.value = statusRes.showGraphs;
        }

        // 2. Alertas Normales -> Exclusivo KPI-Component
        if (alarmsNormalRes.status === 200) {
            normalAlarmsData.value = alarmsNormalRes.data;
        }

        // 3. Alertas Recurrentes -> Exclusivo NetworkChart (MessageComponent)
        if (recurrentRes.status === 200) {
            recurrentAlarmsData.value = recurrentRes.data;
        }

        // 4. Operatividad
        if (operabilityRes.status === 200) {
            operabilityData.value = operabilityRes.data;
        }

        // 5. Data del Mapa
        mapData.value = {
            rxlvlSnr: rxlvlSnrRes.status === 200 ? rxlvlSnrRes.data : [],
            latency: latencyRes.status === 200 ? latencyRes.data : [],
            hexagon: hexagonRes.status === 200 ? hexagonRes.data : null,
            pmpsm: pmpsmRes.data || [],
            rajant: rajantRes.data || [],
            pmpap: pmpapRes.data || [],
            polylines: polylinesRes.data || []
        };

        // Guardar estado general de KPIs en Store
        store.commit('setTotalKPI', {
            distri: { valor: STRING_GENERAL.distri, alarm: normalAlarmsData.value.distri, total: operabilityData.value.distribución, count: countEquipStatus.value.distri },
            acceso: { valor: STRING_GENERAL.access, alarm: normalAlarmsData.value.acceso, total: operabilityData.value.acceso, count: countEquipStatus.value.acceso },
            client: { valor: STRING_GENERAL.client, alarm: normalAlarmsData.value.client, total: operabilityData.value.cliente, count: countEquipStatus.value.client }
        });

    } catch (error) {
        store.commit('showSnackBar', { type: LABELS.error, msg: t('snackbar.errorApis'), valor: true });
    }
}

async function restarInfo() {
    valorCount.value = 0;
    await fetchAllDashboardData();
}

onMounted(async () => {
    await fetchAllDashboardData();
    interval.value = setInterval(async () => {
        if (valorCount.value >= 100) {
            await restarInfo();
        } else {
            valorCount.value += INTERVALRECARGE;
        }
    }, 1000);
});

onBeforeUnmount(() => {
    if (interval.value) clearInterval(interval.value);
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (projectName.value !== 'SmartLinkRAOS')
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "ma-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              class: "pa-0",
              cols: "12",
              sm: "12",
              md: "12",
              lg: "12",
              xl: "12",
              xxl: "12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  class: "ma-4 pa-4 mb-0 mt-0 py-0",
                  style: {"border-radius":"10px"},
                  elevation: "0",
                  color: "bgtopology"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          justify: "space-between",
                          class: "ma-0",
                          style: {"align-items":"center"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('labels.linkMap')), 1),
                            _createVNode(_component_v_progress_circular, {
                              class: "circular_btn",
                              rotate: 360,
                              size: 25,
                              width: 5,
                              "model-value": valorCount.value,
                              color: "bgCircular",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (restarInfo()))
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, {
                      class: _normalizeClass(["pr-0", statusEquips.value.length > 0 ? '' : 'text-center'])
                    }, {
                      default: _withCtx(() => [
                        (showNetWork.value)
                          ? (_openBlock(), _createBlock(NetworkChart, {
                              key: 0,
                              "lat-lng-sm": mapData.value.pmpsm,
                              "lat-lng-raj": mapData.value.rajant,
                              "lat-lng-ap": mapData.value.pmpap,
                              "polylines-data": mapData.value.polylines,
                              "rxlvl-snr-data": mapData.value.rxlvlSnr,
                              "latency-data": mapData.value.latency,
                              "hexagon-data": mapData.value.hexagon,
                              "recurrent-alarms": recurrentAlarmsData.value
                            }, null, 8, ["lat-lng-sm", "lat-lng-raj", "lat-lng-ap", "polylines-data", "rxlvl-snr-data", "latency-data", "hexagon-data", "recurrent-alarms"]))
                          : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, { class: "ma-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "pa-0"
        }, {
          default: _withCtx(() => [
            (showKPI.value)
              ? (_openBlock(), _createBlock(KPICOMPONENT, {
                  key: 0,
                  "count-equip-status": countEquipStatus.value,
                  "alarm-data": normalAlarmsData.value,
                  "operability-data": operabilityData.value
                }, null, 8, ["count-equip-status", "alarm-data", "operability-data"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})